import { LegacyDevice } from './device';
import { Capability } from './device-capability';
import { WiFi } from 'z3k-config';
import { getDeviceSpecV2 } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { getGsmLevel } from 'console/shared/components/indicators/gsm/utils';
import { isWiFiNotConfigured, rssiBar, } from 'console/shared/components/indicators/wifi/utils';
export function getDeviceConnectionConfig(device) {
    const { device_type, hardware_type, z3k_config } = device;
    const device_spec = getDeviceSpecV2(device_type?.code, hardware_type?.code);
    const has_device_gsm = LegacyDevice.has_capability(device?.capabilities, Capability.has_gsm);
    const has_z3k_device_gsm = has_device_gsm && z3k_config?.gsm_settings != null;
    const has_gsm = device_spec ? has_z3k_device_gsm : has_device_gsm;
    const has_device_wifi = LegacyDevice.has_capability(device?.capabilities, Capability.has_wifi_v2);
    const has_legacy_wifi = LegacyDevice.has_capability(device?.capabilities, Capability.has_wifi);
    const has_z3k_device_wifi = !!(has_device_wifi &&
        device_spec?.network.has_wifi &&
        z3k_config?.wifi_settings?.is_enabled);
    const has_wifi = device_spec ? has_z3k_device_wifi : has_device_wifi;
    const has_ethernet = LegacyDevice.has_capability(device?.capabilities, Capability.has_ethernet);
    //TODO: add via connection
    return { has_gsm, has_ethernet, has_wifi, has_legacy_wifi };
}
export function getDeviceGsmIcon(device) {
    const { gsm_state, radiosilence } = device;
    const { gsm_bars } = getGsmLevel(gsm_state);
    return radiosilence
        ? 'gsm-radiosilence'
        : gsm_bars != null
            ? `gsm-${gsm_bars}`
            : 'gsm-no';
}
export function getDeviceLegacyWiFiIcon(device) {
    const { gsm_state } = device;
    const { gsm_bars } = getGsmLevel(gsm_state);
    return gsm_bars != null ? `wifi-${gsm_bars}` : 'wifi-no';
}
export function getDeviceWiFiIcon(device) {
    const { wifi_state, z3k_config } = device;
    const configured = !isWiFiNotConfigured(z3k_config?.wifi_settings);
    const connected = WiFi.isConnectedViaWiFi(wifi_state);
    const rssi = rssiBar(wifi_state?.rssi);
    return configured
        ? connected
            ? `wifi-${rssi}`
            : 'wifi-no'
        : 'wifi-not-configured';
}
export function getDeviceEthernetIcon(device) {
    const { ethernet_state } = device;
    return ethernet_state?.is_connected ? 'ethernet' : 'ethernet-no';
}
